<template>
    <div class="x_box">
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h5>{{$t('sale_order')}}</h5>
                            <table class="table table-bordered table-striped table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                                        <th>{{$t('code')}}</th>
                                        <th>{{$t('date')}}</th>
                                        <th class="text-right" style="width: 120px;">{{$t('grand_total')}}</th>
                                        <th class="text-right" style="width: 120px;">{{$t('discount')}}</th>
                                        <th class="text-right" style="width: 120px;">{{$t('untax_amount')}}</th>
                                        <th class="text-right" style="width: 120px;">{{$t('taxes')}}</th>
                                        <th class="text-right" style="width: 120px;">{{$t('total_amount')}}</th>
                                        <th class="text-right" style="width: 120px;">{{$t('total')}}</th>
                                        <th style="width: 80px;"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in orders" :key="index">
                                        <td class="text-center">{{index+1}}</td>
                                        <td>{{ret.Num}}</td>
                                        <td>{{ret.Date}}</td>
                                        <td class="text-right">{{ret.GrandTotal}}</td>
                                        <td class="text-right">{{ret.Discount}}</td>
                                        <td class="text-right">{{ret.UntaxAmount}}</td>
                                        <td class="text-right">{{ret.TaxVat}}</td>
                                        <td class="text-right">{{ret.PaidAmount}}</td>
                                        <td class="text-right">{{ret.TotalAmount}}</td>
                                        <td class="text-center">
                                            <button type="button" class="btn btn-danger btn-sm" @click="onCalOrder(ret)">Calculate</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-sm-12">
                            <h5>{{$t('sale_invoice')}}</h5>
                            <table class="table table-bordered table-striped table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                                        <th>{{$t('code')}}</th>
                                        <th>{{$t('date')}}</th>
                                        <th class="text-right" style="width: 120px;">{{$t('grand_total')}}</th>
                                        <th class="text-right" style="width: 120px;">{{$t('discount')}}</th>
                                        <th class="text-right" style="width: 120px;">{{$t('untax_amount')}}</th>
                                        <th class="text-right" style="width: 120px;">{{$t('taxes')}}</th>
                                        <th class="text-right" style="width: 120px;">{{$t('total_amount')}}</th>
                                        <th class="text-right" style="width: 120px;">{{$t('total')}}</th>
                                        <th style="width: 80px;"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in invoices" :key="index">
                                        <td class="text-center">{{index+1}}</td>
                                        <td>{{ret.Num}}</td>
                                        <td>{{ret.Date}}</td>
                                        <td class="text-right">{{ret.GrandTotal}}</td>
                                        <td class="text-right">{{ret.Discount}}</td>
                                        <td class="text-right">{{ret.UntaxAmount}}</td>
                                        <td class="text-right">{{ret.TaxVat}}</td>
                                        <td class="text-right">{{ret.PaidAmount}}</td>
                                        <td class="text-right">{{ret.TotalAmount}}</td>
                                        <td class="text-center">
                                            <button type="button" class="btn btn-danger btn-sm" @click="onCalInvoice(ret)">Calculate</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                orders: [],
                invoices: []
            }
        },
        created(){
            this.toList();
        },
        methods: {
            toList(){
                var loading = this.$loading.show();
                this.$api().post('sale/invalid-calculation').then(res => {
                    if(this.$isValid(res)){
                        this.orders = res.data.Json.Orders;
                        this.invoices = res.data.Json.Invoices;
                        console.log(res);
                    }
                }).finally(function(){ loading.hide(); });
            },
            onCalOrder(line){
                var loading = this.$loading.show();
                var req = {
                    Id: line.Id,
                    Status: 'Order'
                };
                this.$api().post('sale/update-calculation', req).then(res => {
                    if(this.$isValid(res)){
                        this.toList();
                    }
                }).finally(function(){ loading.hide(); });
            },
            onCalInvoice(line){
                var loading = this.$loading.show();
                var req = {
                    Id: line.Id,
                    Status: 'Invoice'
                };
                this.$api().post('sale/update-calculation', req).then(res => {
                    if(this.$isValid(res)){
                        this.toList();
                    }
                }).finally(function(){ loading.hide(); });
            }
        }
    }
</script>